import axiosPrivateInstance from 'middlewares/AxiosInstance'

const getAllTechnicians = () =>
axiosPrivateInstance.get('/users/technicians')

export default { getAllTechnicians }
